import React from 'react'

function What() {
    return (
        <div className="what">
            <div className="what-content1">
                <img src="./img/unsplash_wB9VldR8OHM.jpg" alt="" />
            </div>
            <div className="what-content2">
                <h1>What we do</h1>
                <p>
                    Our large database provides us access to thousands 
                    of job openings across various locations and of all 
                    role-types, we spot companies whose values and work 
                    culture align with your desires, competitive salaries 
                    across all board and clearly spelt out job requirements, 
                    all you need do is tell us your skillset and the job you’re looking for.
                    </p>
                <p>
                    Let us help you work smart—a pool of job offers at your 
                    discretion with little effort, save time—be productive 
                    at work while looking for other sources of income, 
                    personalize your search—provide details on your dream job, salary and other job benefits.
                </p>
                <p>
                    We value you and the security of your information so be 
                    rest assured that your information is in safe hands and will not be used without your consent.                </p>
            </div>
        </div>
    )
}

export default What
